<template>

  <v-footer dark padless v-if="!isSmallDevice" app absolute>

    <v-card flat tile class="indigo lighten-1 white--text text-center flex-grow-1">

      <!-- social networks
      <v-card-text>
        <v-btn v-for="icon in icons" :key="icon" class="mx-4 white--text" icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>
-->
      <!-- footer text -->
      <v-card-text class="white--text pt-0 d-none d-md-flex" style ="margin-top: 1rem;">
        <a href="/app/p/api/v1/loc/cgu/rental" style="color: white;padding-right: 1rem;">
          Conditions Générales de Ventes.</a>
        <a href="/app/p/api/v1/loc/cgu/driver" style="color: white;">Conditions Générales d'utilisation.</a>
      </v-card-text>

      <v-divider></v-divider>
      <!-- trademark -->
      <v-card-text class="white--text">
        {{ new Date().getFullYear() }}   <strong style="padding:0 1rem 0 1rem">Carloc - {{ $t('main.home.'+appName+'.name') }} </strong>    {{ $t('main.droits') }}

        <small style="font-size: 10px;    padding-left: 14px;">Version : {{appVersion}} - {{buildTime}} </small>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "Footer",
    data () {
      return {
        icons: [
          'mdi-facebook',
          'mdi-twitter',
          'mdi-linkedin',
          'mdi-instagram',
        ]
      };
    },
    computed: {
      ...mapGetters({
        appName: 'main/appName',
        buildTime: 'main/buildTime',
        appVersion: 'main/appVersion'
      })
    }
  }
</script>

<style scoped>
  .bottomPage {
    font-size: .5rem !important;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
</style>
